
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[...type]",
      function () {
        return require("private-next-pages/auth/[...type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[...type]"])
      });
    }
  